import { Pipe, PipeTransform } from '@angular/core';
import { OutageType } from '../models/power-outage.model';

@Pipe({
  name: 'outageType',
})
export class OutageTypePipe implements PipeTransform {
  transform(type: OutageType) {
    switch (type) {
      case 'Planned':
        return 'vedlikehold';
      case 'Unplanned':
      default:
        return 'strømbrudd';
    }
  }
}
